import assetPath from '/app/xinglets/career-hub/main-entry/src/images/logged-out-career-hub-header.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')